/**
 * 房源管理路由
 */
export default {
  path: '/house',
  name: 'house',
  redirect: '/house/houseType',
  component: () => import('../views/house/index.vue'),
  meta: {
    headerTitle: '房源',
    icon: 'ab-iconfont ab-icon-home',
    auth: 1009
  },
  children: [
    {
      path: 'houseType',
      name: 'houseType',
      redirect: '/house/houseType/houseTypeManage',
      component: () => import('../views/house/houseType/index.vue'),
      meta: {
        headerTitle: '房型管理',
        icon: 'house'
      },
      children: [
        {
          path: 'houseTypeManage',
          name: 'houseTypeManage',
          redirect: '/house/houseType/houseTypeManage/houseTypeList',
          component: () => import('../views/house/houseType/houseTypeManage/index.vue'),
          meta: {
            headerTitle: '房型管理'
          },
          children: [
            {
              path: 'houseTypeList',
              name: 'houseTypeList',
              component: () => import('../views/house/houseType/houseTypeManage/list.vue'),
              meta: {
                headerTitle: '房型管理'
              }
            },
            {
              path: 'houseTypeRoomDetail',
              name: 'houseTypeRoomDetail',
              component: () => import('../views/house/houseType/houseTypeManage/roomDetail.vue'),
              meta: {
                headerTitle: '编辑房间信息',
                hasBreadcrumb: true,
                isDetailPage: true
              }
            },
            {
              path: 'houseTypeRoomSort',
              name: 'houseTypeRoomSort',
              component: () => import('../views/house/houseType/houseTypeManage/houseRoomSort.vue'),
              meta: {
                headerTitle: '排序',
                hasBreadcrumb: true,
                isDetailPage: true
              }
            }
          ]
        },
        {
          path: 'groupList',
          name: 'groupList',
          component: () => import('../views/house/houseType/group/list.vue'),
          meta: {
            headerTitle: '分组管理'
          }
        }
      ]
    },
    {
      path: '/hotel',
      name: 'hotel',
      component: () => import('../views/house/hotel/index.vue'),
      meta: {
        headerTitle: '门店管理',
        icon: 'hotel'
      }
    },
    {
      path: '/ownerManage',
      name: 'ownerManage',
      redirect: '/ownerManage/ownerList',
      component: () => import('../views/house/ownerManage/index.vue'),
      meta: {
        headerTitle: '业主管理',
        icon: 'owner',
        noShowMenu: true
      },
      children: [
        {
          path: 'ownerList',
          name: 'ownerList',
          component: () => import('../views/house/ownerManage/list.vue'),
          meta: {
            headerTitle: '业主管理'
          }
        },
        {
          path: 'ownerCreate',
          name: 'ownerCreate',
          component: () => import('../views/house/ownerManage/create.vue'),
          meta: {
            headerTitle: '新建业主',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        },
        {
          path: 'ownerCreate',
          name: 'ownerEdit',
          component: () => import('../views/house/ownerManage/create.vue'),
          meta: {
            headerTitle: '修改业主',
            hasBreadcrumb: true,
            isDetailPage: true
          }
        }
      ]
    }
  ]
}
